import { useEffect, useRef } from "react";
import { Download, Receipt, Share2 } from "lucide-react";
import { buildInvoiceCanvas, downloadInvoice, shareInvoiceWA } from "../lib/invoiceImage";
import { Button } from "./ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "./ui/dialog";

export function InvoiceDialog({ invoice, onClose }) {
  const ref = useRef(null);

  useEffect(() => {
    if (!invoice) return;
    let cancelled = false;
    let frames = 0;
    const render = () => {
      if (cancelled) return;
      // Konten dialog (Radix portal) bisa termount setelah effect — coba ulang beberapa frame
      if (!ref.current) {
        if (frames++ < 60) requestAnimationFrame(render);
        return;
      }
      const holder = ref.current;
      buildInvoiceCanvas(invoice).then((canvas) => {
        if (cancelled || !ref.current) return;
        holder.innerHTML = "";
        canvas.style.width = "100%";
        canvas.style.height = "auto";
        canvas.style.borderRadius = "10px";
        holder.appendChild(canvas);
      });
    };
    render();
    return () => { cancelled = true; };
  }, [invoice]);

  return (
    <Dialog open={!!invoice} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md max-h-[92vh] overflow-y-auto" data-testid="dialog-invoice">
        <DialogHeader>
          <DialogTitle className="font-heading flex items-center gap-2"><Receipt className="w-5 h-5 text-[#F04E23]" /> Invoice {invoice?.no}</DialogTitle>
          <DialogDescription>{invoice?.nama} — {invoice?.paket} • {invoice?.bulan}</DialogDescription>
        </DialogHeader>
        <div ref={ref} className="rounded-lg overflow-hidden border border-border bg-white" data-testid="invoice-preview" />
        <div className="grid grid-cols-2 gap-2">
          <Button className="bg-sky-600 hover:bg-sky-500" onClick={() => downloadInvoice(invoice)} data-testid="btn-invoice-download">
            <Download className="w-4 h-4 mr-1.5" /> Unduh Gambar
          </Button>
          <Button className="bg-[#25D366] hover:bg-[#1fb857] text-white" onClick={() => shareInvoiceWA(invoice)} data-testid="btn-invoice-share">
            <Share2 className="w-4 h-4 mr-1.5" /> Share WA
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
